module.exports = __webpack_public_path__ + "static/media/main-screen-card-lost-dog-cat.4f285e68.png";